'use client';

import { Dispatch, FC, SetStateAction, useEffect } from 'react';
import AxiosInstance, { AxiosRequestConfig } from 'axios';
import { OptionTypes } from '@/types';
import { Specification } from '@/stores/configurator';
import Skeleton from 'react-loading-skeleton';
import InputSelect from '../select/InputSelect';
import { stylesSelect } from '@/utils';

export interface ProductState {
  specs: Specification;
  hasLoaded: Boolean;
  hasDownloads: Boolean;
}

export type ProductType = 'product1' | 'product2';

export const ProductCompareSelectors: FC<{
  options?: OptionTypes[] | any[];
  selectedModel?: OptionTypes | any;
  setSelectedModel: Dispatch<SetStateAction<OptionTypes | any>>;
  product: ProductState;
  setProduct: Dispatch<SetStateAction<Specification | any>>;
}> = ({ options, product, setProduct, selectedModel, setSelectedModel }) => {
  const axios = AxiosInstance.create({
    baseURL: process.env.API_ENDPOINT,
  });

  const getProductByModelNumber = async ({
    model,
    setState,
    params,
  }: {
    model: string;
    setState: Dispatch<SetStateAction<any>>;
    params?: AxiosRequestConfig;
  }) => {
    product.hasLoaded = false;
    try {
      const { data, status } = await axios.get(
        `configurator/by-model-number/${model}`,
        { params }
      );
      if (status == 200) {
        setState(data?.data);
      } else {
        throw Error;
      }
    } catch (error) {
      console.error('Error get product by model no :', error);
    }
  };

  useEffect(() => {
    if (selectedModel?.value) {
      getProductByModelNumber({
        model: selectedModel?.value,
        setState: setProduct,
      });
      product.hasLoaded = true;
    } else {
      setProduct({});
    }
  }, [selectedModel]);

  return (
    <div className='flex h-full w-full flex-col items-stretch justify-start gap-6 rounded-xl border border-[#DCE0E3] bg-white p-3 md:rounded-3xl lg:p-6'>
      {!(selectedModel && product.specs.image_1) ? (
        <Skeleton className='h-[10rem] w-full object-contain sm:h-[20rem]' />
      ) : product.specs.image_1 ? (
        <img
          src={product.specs.image_1}
          alt='image'
          title='image'
          className='block h-[10rem] w-full object-contain sm:h-[20rem]'
        />
      ) : (
        <div
          className='h-[10rem] justify-start gap-6 rounded-3xl bg-[#EFF4FA] p-3 sm:h-[20rem] lg:p-6'
          style={{ textAlign: 'center', alignContent: 'center' }}
        >
          <h6>Product image unavailable</h6>
        </div>
      )}
      <div className='w-full'>
        <InputSelect
          customStyles={stylesSelect}
          value={selectedModel}
          onChange={setSelectedModel}
          error=''
          className='text-gray-5 w-full text-sm font-normal'
          classNamePrefix=''
          formatOptionLabel={''}
          instanceId='phone_type'
          isMulti={false}
          isDisabled={false}
          placeholder='Select type'
          options={options}
          icon=''
          isClearable
        />
      </div>
    </div>
  );
};
